import "./insDonutChart.scss";
import React, { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { InsLabelValueTooltip } from "../../base/common/insLabelValueTooltip";
import { InsHighcharts } from "../../base/insHighcharts";
import { donutChartDataLabelFormatter } from "./ins-donut-chart-formatter";
import { numberFormatters } from "common/number-formatters";
import { NumberFormatKind } from "common/types";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { useSelectedValues, useShownValues, useWidgetComponentProps, useWidgetCurrentDisplayValueType, useWidgetCurrentSortBy } from "components/widgets/hooks/use-current-widget";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { applyUserSettings } from "hooks/widget-data/user-settings/user-settings";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
export const InsDonutChart = (props) => {
    const { sectionId, widgetId } = props, displayValueType = useWidgetCurrentDisplayValueType(sectionId, widgetId), selectedValues = useSelectedValues(sectionId, widgetId), shownValuesSetting = useShownValues(sectionId, widgetId), sortedBy = useWidgetCurrentSortBy(sectionId, widgetId), widgetProps = useWidgetComponentProps(sectionId, widgetId);
    const [[data], queryState] = useGetDatapointsWidgetData(props), selectedDropDownProps = Object.entries(selectedValues || {}).map(([key, value]) => widgetProps.dataSelectProps[parseInt(key, 10)].selectValues[value]);
    const displayKind = selectedDropDownProps[0]?.valueFormat ?? widgetProps.valueFormat, series = useMemo(() => {
        if (data?.data?.length === 0) {
            return [];
        }
        let [{ series: raw }] = data?.data ?? [{ series: [] }];
        if (raw) {
            raw = applyUserSettings(raw.filter((val) => val.y), { shownValues: shownValuesSetting, sortBy: sortedBy }, widgetProps.colorSet === "esg", "esg-donut-color", true);
        }
        return raw || [];
    }, [data?.data, shownValuesSetting, sortedBy, widgetProps.colorSet]);
    const format = data?.additionalData?.format;
    const titleFormatUnit = displayKind ? ChartSelectValueFormatKind[displayKind] : ChartSelectValueFormatKind.compact;
    const numberFormatKind = NumberFormatKind[titleFormatUnit] === NumberFormatKind.percent
        ? NumberFormatKind.percent
        : NumberFormatKind.compact;
    const displayFormatKind = displayKind ?? ChartSelectValueFormatKind[format];
    const options = {
        chart: {
            className: "highchart-donut-widget",
            colorCount: widgetProps.colorCount ?? 10,
            plotShadow: false,
            style: { fontFamily: "inherit" },
            styledMode: true,
            type: "pie"
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            pie: {
                center: ["50%", "50%"]
            },
            series: {
                animation: false
            }
        },
        series: [
            {
                data: series,
                dataLabels: {
                    connectorShape: "crookedLine",
                    crookDistance: 0.5,
                    distance: 25,
                    formatter() {
                        return donutChartDataLabelFormatter(this, displayFormatKind, displayValueType);
                    },
                    useHTML: true
                },
                innerSize: "80%",
                type: "pie"
            }
        ],
        title: {
            align: "center",
            text: `<div class="div-title title">${numberFormatters(data?.additionalData?.sum, numberFormatKind, { maximumSignificantDigits: 3 })}</div>`,
            useHTML: true,
            verticalAlign: "middle"
        },
        tooltip: {
            formatter() {
                return renderToStaticMarkup(React.createElement(InsLabelValueTooltip, { labelValuePairs: this.point.options.custom?.tooltip || [] }));
            }
        }
    };
    return React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: Boolean(series?.length) },
        React.createElement(InsHighcharts, { key: `${shownValuesSetting.filter}-${shownValuesSetting.quantity}-${sortedBy}`, options: options, colorSet: widgetProps.colorSet, sectionId: sectionId, widgetId: widgetId, isMaximizedOne: props.isMaximizedOne }));
};
